/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

export const hasActiveSkuRef = (entitlements, skuRef) => {
  const active = entitlements?.entitlements?.filter(e => e.status === 'ACTIVE') || [];

  return active.some(e => e?.skuRef === skuRef);
};
